<template>
  <div>
    <div>
      <img src="@/assets/blue_sad.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "NoRight"
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/Public/NoRight.vue